import React from 'react'
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  withStyles
} from '@material-ui/core'
import { MetricIcon } from '../../icons'
import { getLang } from '../app/selectors/lang'
import { titleCase } from '../../../shared/utils'

export const styles = theme => ({
  root: {
    position: 'relative',
    margin: theme.spacing(0, 1),
    width: `calc(100% - ${theme.spacing(2)}px)`,
    borderRadius: theme.shape.borderRadius,
  },
  avatar: {
    display: 'flex',
    fontSize: 24,
    minWidth: 40,
    marginTop: theme.spacing(0.75),
    marginBottom: 'auto'
  },
  text: {
    margin: theme.spacing(0, 1, 0, 0),
  },
  textPrimary: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(12),
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(14)
    }
  }
})

const SedaKeyMetricListHeader = ({
  groupName,
  classes,
  ...props
}) => {
  const title = titleCase(getLang('LABEL_'+groupName))
  const description = titleCase(getLang('LABEL_REFLECTS_'+groupName))

  return (
    <ListItem
      classes={{
        root: classes.root,
        selected: classes.selected
      }}
      {...props}>
      <ListItemAvatar className={classes.avatar}>
        <MetricIcon metricId={groupName} />
      </ListItemAvatar>
      <ListItemText
        classes={{
          root: classes.text,
          primary: classes.textPrimary
        }}
        primary={title}
        // secondary={description}
      />
    </ListItem>
  )
}

SedaKeyMetricListHeader.propTypes = {}

export default withStyles(styles)(SedaKeyMetricListHeader)
